import React, { forwardRef } from 'react';

import s from './ScrollContainerHorizontal.scss';

/**
 * Responsible for custom horizontal scrollbar
 */
export const ScrollContainerHorizontal = forwardRef<HTMLDivElement, React.PropsWithChildren<{}>>(
  ({ children }, ref) => {
    return (
      <div ref={ref} className={s.scrollContainerHorizontal}>
        {children}
      </div>
    );
  },
);
